import { connect } from "react-redux";
import { commonSlice, contentSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import {
  Content,
  MenuOptions,
  PageHeaderOptionItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import { ContentType, openContent } from "../store/reducers/contentSlice";
import {
  PageOfflineDispach,
  PageOfflineState,
  PageOffline,
} from "senac-components/dist/pages/Mobile/PageOffline";

const mapState = (state: RootState) => {
  var contents = state.contentState.allContents
    .map((content) => ({
      ...content,
      references: content.references?.filter((contentReference) =>
        Boolean(contentReference.downloadProgress)
      ),
    }))
    .filter(
      (p) =>
        p.references?.find(
          (r) => r.downloadProgress && r.downloadProgress >= 100
        ) != undefined
    );

  let result: PageOfflineState = {
    contents,
    title: "Downloads",
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageOfflineDispach = {
    onClickContent: (data: Content) => {
      dispatch(contentSlice.actions.setActiveContentUid(data.uid));
      dispatch(
        openContent([ContentType.Preference, ContentType.Epub, ContentType.Pdf])
      );
    },

    onClickReference(referenceType, content) {
      const reference =
        referenceType === "PDF" ? ContentType.Pdf : ContentType.Epub;
      dispatch(
        contentSlice.actions.openOfflineContent({
          uid: content?.uid,
          referenceType: reference,
        })
      );
    },
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageHeaderOptionItem) =>
      dispatch(commonSlice.actions.goToPageOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
  };

  return result;
};

const WPageOffline = connect(mapState, mapDispatch)(PageOffline);

export { WPageOffline };
